import { getData } from 'utils';
import { LocalJsonStorage } from 'utils/storage';

export const ADMIN_ORGANIZATION_STORAGE_KEY = 'admin-provider/organization';

/** Map DebounceSelect option to persisted org shape { id, name, ... }. */
export function normalizeOrganizationOption(option) {
  if (!option) return null;
  if (option.id != null) return option;
  return { id: option.value, name: option.label };
}

/** Fix org objects persisted as labelInValue { value, label } without id. */
export function repairPersistedOrganization(organization) {
  if (!organization) return null;
  if (organization.id != null) return organization;
  if (organization.value == null) return organization;
  return {
    ...organization,
    id: organization.value,
    name: organization.name ?? organization.label,
  };
}

export function persistOrganizationSelection(organization) {
  LocalJsonStorage.set({ key: ADMIN_ORGANIZATION_STORAGE_KEY, value: organization });
}

/** Switch AdminContext org and navigate into console (Platform deep-links). */
export function openConsoleForOrg({
  org,
  setOrganization,
  navigate,
  path = '/console',
}) {
  if (!org?.id) return;
  const ctx = { id: org.id, name: org.name };
  persistOrganizationSelection(ctx);
  setOrganization(ctx);
  const separator = path.includes('?') ? '&' : '?';
  navigate(`${path}${separator}organizationId=${org.id}`);
}

/** True when deep-link org switch effect has nothing to do. */
export function shouldSkipDeepLinkOrganizationSwitch({
  requestedOrgId,
  organizationId,
  selectedOrganization,
}) {
  if (!requestedOrgId) return true;

  const matchesRequested = String(organizationId) === String(requestedOrgId);
  const hasName = selectedOrganization?.name
    && String(selectedOrganization.id) === String(requestedOrgId);

  return Boolean(matchesRequested && hasName);
}

export function findOrganizationInList(organizationsResponse, requestedOrgId) {
  return getData(organizationsResponse)?.results?.find(
    (organization) => String(organization.id) === String(requestedOrgId),
  );
}

/** Normalize GET /organizations/:id/ payload to persisted org context shape. */
export function normalizeOrganizationFromDetails(response) {
  const orgData = getData(response);
  const details = orgData?.data ?? orgData;
  if (!details?.id) return null;
  return {
    id: details.id,
    name: details.name,
    ...details,
  };
}
